import { loadStripe } from "@stripe/stripe-js";

// Get Stripe publishable key from environment
const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

if (!stripePublishableKey) {
  console.error('VITE_STRIPE_PUBLISHABLE_KEY is not set in environment variables');
}

// Initialize Stripe with publishable key
// Note: In edge functions, use STRIPE_SECRET_KEY from environment
export const stripePromise = loadStripe(stripePublishableKey || '');
